import { createFileRoute } from '@tanstack/react-router';
import { ensureCatalogEntries } from '@/features/catalog/queries';
import { providerProfiles } from '@/features/catalog/providerProfiles';
import { ProviderDirectoryPage } from '../../../pages/providers/ProviderDirectoryPage';
import { staticPageHead } from '../../../lib/seo/staticPageHead';

export const Route = createFileRoute('/_site/providers/')({
  staticData: { footer: 'slim' },
  loader: async ({ context }) =>
    providerProfiles(await ensureCatalogEntries(context.queryClient)),
  head: () =>
    staticPageHead({
      path: '/providers',
      title: 'API Providers and Traffic - AnyAPI',
      // The profiles this page links are already noindex because they are thin
      // and exist to satisfy provider anonymity (providers/$providerId.tsx).
      // This directory renders every one of their names in server HTML, so the
      // parent was the surface still putting them in the index. Crawlable so
      // the noindex is seen, `follow` so the profile links still resolve.
      robots: 'noindex, follow',
      description: 'Browse AnyAPI providers ranked by successful traffic and see every endpoint they serve.',
      crumb: 'Providers',
      og: { title: 'API Providers and Traffic - AnyAPI' },
    }),
  component: ProviderDirectoryRoute,
});

function ProviderDirectoryRoute() {
  return <ProviderDirectoryPage initialProfiles={Route.useLoaderData()} />;
}
